export default __webpack_public_path__ + "static/media/evaluations-icon.ae76ff11.svg";